import React from "react";

const SvgTwo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="138"
    height="138"
    viewBox="0 0 138 138"
    fill="none"
  >
    <circle cx="69" cy="69" r="69" fill="#FFF9F9" fillOpacity="0.13" />
  </svg>
);

export default SvgTwo;
